<template>
  <div class="bg-white" style="padding: 15px">
    <h4 class="form-title">Inspection Documents</h4>
    <DocList></DocList>
    <el-row>
      <el-col :sm="12">
        <el-upload
          :action="api.href"
          :headers="api.headers"
          accept="application/pdf"
          :data="{ q: 'documents' }"
          :show-file-list="false"
          :on-success="handleUploadSuccess"
          :before-upload="beforeUpload"
          :disabled="isLoading"
        >
          <el-button size="small" type="primary" :disabled="isLoading"
            ><i v-if="isLoading" class="el-icon-loading"></i> Upload</el-button
          >
        </el-upload>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import api from "@/api";
import InspectionSheet from "@/models/InspectionSheet";
import DocList from "./doc-list.vue";
export default {
  name: "docs",
  components: { DocList },
  computed: {
    api() {
      return {
        headers: {
          // "Content-Type": "multipart/form-data",
          Authorization: `${this.$store.getters["auth/token"].token_type} ${this.$store.getters["auth/token"].access_token}`,
          "X-Requested-With": "XMLHttpRequest"
        },
        href: new URL("/api/v1/inventory/fileupload/", api.baseUrl).href
      };
    },
    inspectionSheet() {
      return this.$store.getters["stockin/inspectionSheet"];
    }
  },
  data() {
    return {
      // docs: [],
      isLoading: false
    };
  },
  methods: {
    beforeUpload() {
      this.isLoading = true;
    },
    download(doc) {
      api.download(`/api/v1/inventory/document_list/?id=${doc.id}`, {
        name: "Inspection Sheet Document",
        ext: ".pdf"
      });
    },
    handleUploadSuccess(resp) {
      if (resp.data.hasOwnProperty("code") && resp.data.code == 200) {
        // this.docs.push(resp.data.msg);
        var file_dir = resp.data.msg;
        // save after receiving the response
        var data = {
          inspection_id: this.inspectionSheet.id,
          docs: file_dir
          // docs: this.docs.toString()
        };
        InspectionSheet.postDocument(data).then(resp => {
          this.isLoading = false;
          if (resp.hasOwnProperty("code") && resp.code == 200) {
            // this.docs.push({
            //   id: resp.id,
            //   file_dir: file_dir
            // });
            this.$store.dispatch("stockin/getDocs");
            this.$notify({
              type: "success",
              message: "File upload successful.",
              position: "bottom-right"
            });
          }
        });
      }
    }
  },
  mounted() {
    // this.$nextTick(() => {
    // set the docs attached for the inspection sheet
    // this.fetchDocs();
    // });
  }
};
</script>

<style lang="css" scoped></style>
